var _style, _circle, _circle2, _circle3, _circle4, _path, _path2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStressVeryHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#FF0000;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FF0000;stroke-width:7;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100.6,
    cy: 100,
    r: 90.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.4,
    cy: 101,
    r: 79.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 63.4,
    cy: 77.5,
    r: 11.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 137.4,
    cy: 77.8,
    r: 11.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.2,132.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.8,126"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "62.4,147.2 81,120 90.4,141.3 102.6,122.9 110.8,142.1 125.8,123.9 138.4,149.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressVeryHigh);
export default __webpack_public_path__ + "static/media/StressVeryHigh.17b652ce2c9128470b8a3bcc12be0edf.svg";
export { ForwardRef as ReactComponent };